import { useFetch } from "@/hooks/useFetch";
import { PageHeader } from "@/components/PageHeader";
import { DataTable } from "@/components/DataTable";
import { Card } from "@/components/ui/card";
import { rupiah, angka } from "@/lib/format";

export default function Reconciliation() {
  const { data, loading } = useFetch("/reconciliation");
  const dot = (ind) => ({ green: "bg-emerald-500", yellow: "bg-amber-500", red: "bg-rose-500" }[ind]);
  const label = (ind) => ({ green: "Sesuai & ditagihkan", yellow: "Belum ditagihkan / belum lengkap", red: "Berbeda / tarif kosong / potensi ganda" }[ind]);

  return (
    <div>
      <PageHeader title="Rekonsiliasi" subtitle="Bandingkan surat jalan, pengembalian, saldo, dan invoice per proyek" />
      <div className="flex flex-wrap gap-4 mb-4 text-sm">
        {["green", "yellow", "red"].map((i) => (
          <div key={i} className="flex items-center gap-2"><span className={`h-3 w-3 rounded-full ${dot(i)}`} /> {label(i)}</div>
        ))}
      </div>
      {loading ? <div className="h-64 rounded-md bg-muted animate-pulse" /> : (
        <DataTable testId="reconciliation" data={data || []} columns={[
          { key: "ind", label: "", sortable: false, render: (r) => <span className={`h-3 w-3 rounded-full inline-block ${dot(r.indicator)}`} /> },
          { key: "client", label: "Klien" },
          { key: "project", label: "Proyek" },
          { key: "delivered", label: "Dikirim", numeric: true, render: (r) => angka(r.delivered) },
          { key: "returned", label: "Kembali Baik", numeric: true, render: (r) => angka(r.returned) },
          { key: "balance", label: "Saldo", numeric: true, render: (r) => angka(r.balance) },
          { key: "invoice_count", label: "Jml Invoice", numeric: true },
          { key: "invoiced_value", label: "Nilai Invoice", numeric: true, render: (r) => rupiah(r.invoiced_value) },
        ]} />
      )}
    </div>
  );
}
